export { onRouterTransitionStart } from "@stadium/services/error-reporting/instrumentation-client";

import "@stadium/services/error-reporting/instrumentation-client";
